import { black, neutral7, primaryLight } from '../../colors';
import { blackExtraLight } from '../../shadows';
import { fontSmoothing, getFontFamily } from '../../typography';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const MuiDateRangePickerDay = (idsTokens = idsTokensDefault) => ({
  root: {
    '&.MuiDateRangePickerDay-rangeIntervalDayHighlight': {
      backgroundColor: primaryLight,
      color: '#fff',
      // squares all edges of selected range
      borderRadius: '0 !important',
    },
    '& .MuiDateRangePickerDay-rangeIntervalDayHighlightEnd': {
      marginRight: 0,
    },
    '& .MuiDateRangePickerDay-rangeIntervalDayHighlightStart': {
      marginLeft: 0,
    },
    '& .MuiDateRangePickerDay-rangeIntervalPreview': {
      border: 'none',
    },
    '& .MuiDateRangePickerDay-dayInsideRangeInterval': {
      '&:hover': {
        backgroundColor: blackExtraLight,
      },
      '& .MuiDateRangePickerDay-MuiPickersDay-dayLabel': {
        color: neutral7,
      },
    },
    '& .MuiDateRangePickerDay-rangeIntervalDayPreview': {
      border: 'none',
      background: primaryLight,
      // squares all edges of preview range
      borderRadius: '0 !important',
    },
    '& .MuiDateRangePickerDay-day': {
      fontFamily: getFontFamily(idsTokens),
      ...fontSmoothing,
      width: 40,
      height: 40,
      fontSize: idsTokens.typography.font.size.base,
      fontWeight: idsTokens.typography.font.weight.medium,
      transform: 'scale(1)',
      '&:hover:not(.MuiPickersDay-daySelected) .MuiPickersDay-dayLabel': {
        color: black,
      },
    },
    '& .MuiDateRangePickerDay-dayOutsideRangeInterval': {
      '&:hover': {
        border: 'none',
      },
    },
  },
});
